import React, { useEffect, useState, useCallback } from "react";
import LabelInput from "../../../../../shared/components/labelInput";
import { useForm } from "react-hook-form";
import { fetchLicenceAuth } from "../../../../../shared/services/simpleListItemsService";
import NewDateTimePicker from "../../../../../shared/components/newDateTimePicker";
import RadioGroup from "../../../../../shared/components/RadioGroup";
import SpRegistrationMapper from "../mappers/spRegistrationMapper";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import SupportNavigationButtons from "../../../components/support/SupportNavigationButtons";
import { handleSupportNext } from "../../../utils/supportNavUtils";
import { useNavigate } from "react-router-dom";
import ukRegistrationValidation from "../../../../../shared/utils/ukRegistrationValidation";
import RegistrationLookup from "../../../../../shared/components/RegistrationLookup/RegistrationLookup";
import FieldStack from "../../../../../shared/components/FieldStack";
import QuoteStepHeading from "../../../../../shared/components/QuoteStepHeading";

const SpRegistration = () => {
  const savedRegistrationData = SpRegistrationMapper.get();
  const formMethods = useForm({
    defaultValues: {
      ...savedRegistrationData,
      pendingVehicleRegis: null,
      prevVehicleRegis: null,
    },
    mode: "onChange",
    shouldUnregister: true,
  });
  const {
    register,
    formState: { errors, isValid },
    watch,
    setValue,
    setError,
    control,
    trigger,
    handleSubmit,
  } = formMethods;

  const [lic, setlic] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const convertArrayFormat = useCallback((array) => {
    if (!Array.isArray(array)) {
      return [];
    }
    return array.map((item) => ({
      value: item.listItemId,
      label: item.listItemDescription,
    }));
  }, []);

  useEffect(() => {
    setIsLoading(true);
    fetchLicenceAuth()
      .then((uber) => setlic(uber))
      .finally(() => setIsLoading(false));
  }, []);

  const onSubmit = (data) => {
    if (!data.prevVehicleRegis) {
      setError("pendingVehicleRegis", {
        type: "manual",
        message: "Please verify the registration before continuing.",
      });
      return;
    }

    SpRegistrationMapper.set(data);
    handleSupportNext(navigate);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <QuoteFormWrapper>
        <QuoteStepHeading title="Registration change" className="tw-mb-6" />
        <FieldStack className="tw-w-full">
        <RegistrationLookup
          formMethods={formMethods}
          registrationValidation={ukRegistrationValidation}
        />
        {watch("prevVehicleRegis") && (
          <>
          <RadioGroup
            name="dvlaNotified"
            mainLabel="Have the DVLA been notified of the change of registration? If no, you must notify the DVLA."
            register={register}
            trigger={trigger}
            errors={errors.dvlaNotified}
          />
          <RadioGroup
            name="licAuthNotified"
            mainLabel="Has the licencing authority been notified of the change of registration? If no, you must notify the licencing authority."
            register={register}
            trigger={trigger}
            errors={errors.licAuthNotified}
          />
          <RadioGroup
            name="exitingLicenseAuth"
            mainLabel="Will your vehicle continue to be licenced by the existing licencing authority disclosed on your policy?"
            register={register}
            trigger={trigger}
            errors={errors.exitingLicenseAuth}
          />
          {watch("exitingLicenseAuth") === "No" && (
            <LabelInput
              id="LicenseAuth"
              label="What will be the licencing authority?"
              type="select"
              options={convertArrayFormat(lic)}
              control={control}
              placeholder="Select licence authority"
              register={register("LicenseAuth", { required: true })}
              errors={errors.LicenseAuth}
              watch={watch("LicenseAuth")}
              trigger={trigger}
              isSearchable={true}
              isLoading={isLoading}
            />
          )}
          <NewDateTimePicker
            name="registrationEffectiveDateTime"
            label="Effective Date and Time"
            errors={errors.registrationEffectiveDateTime}
            setValue={setValue}
            control={control}
            rules={{ required: "Date is required" }}
            watch={watch}
            defaultValue={watch("registrationEffectiveDateTime")}
            minDate={new Date()}
            trigger={trigger}
          />
          </>
        )}
        </FieldStack>
      </QuoteFormWrapper>
      <SupportNavigationButtons
        isValid={isValid && Boolean(watch("prevVehicleRegis"))}
      />
    </form>
  );
};

export default SpRegistration;
